
import { getToken, setToken, removeToken,getLoginName,setLoginName } from '@/utils/auth'


const state = {
  token: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  mobile:getLoginName(), 
  roles: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
	setToken(token)
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_MOBILE: (state, mobile) => {
    state.mobile = mobile
	setLoginName(mobile)
  }
}

const actions = {
  // user login
 
 
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
